import { createFileRoute } from "@tanstack/react-router";
import { PlatformPage } from "@/components/PlatformPage";
import { fakturownia } from "@/lib/integrations-data";
import { buildSeoMeta } from "@/lib/seo";

const PATH = "/integracje/fakturownia";

export const Route = createFileRoute("/integracje/fakturownia")({
  head: () =>
    buildSeoMeta({
      title: "Integracja Fakturownia z Baselinker, Apilo i sklepem | SyncTech",
      description:
        "Automatyczne wystawianie faktur z Baselinker, Apilo, Shopify, Shoper i marketplace'ów przez Fakturownię. JPK, VAT-OSS, integracja z księgowością.",
      path: PATH,
    }),
  component: () => (
    <PlatformPage data={fakturownia} path={PATH} breadcrumbCategory="Integracje" />
  ),
});
